import { ArtifactLink } from './ArtifactLink';
import { ARTIFACT_TYPE_LABELS, type ArtifactSummary } from '@thottbot/shared';

export function ArtifactTable({
  items,
  showType = false,
}: {
  items: ArtifactSummary[];
  showType?: boolean;
}) {
  if (items.length === 0) return <p className="muted">Nothing here yet.</p>;
  return (
    <div className="table-scroll">
      <table className="grid">
        <thead>
          <tr>
            <th>Name</th>
            {showType && <th>Type</th>}
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {items.map((a) => (
            <tr key={a.id}>
              <td>
                <ArtifactLink type={a.type} slug={a.slug} name={a.name} />
              </td>
              {showType && <td>{ARTIFACT_TYPE_LABELS[a.type].singular}</td>}
              <td>{a.summary}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
